import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
  templateUrl: './email-forwarding-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './email-forwarding-info.component.scss',
})
export class EmailForwardingInfoComponent {}
